/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { MembersPageUserFragmentDoc, OrgUserFragmentDoc, MembersPageInvitedUserFragmentDoc } from './fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'QueryPrediction', users: Array<{ __typename?: 'UserType', status: Types.ApprovalStatus | null | undefined, id: string, name: string | null | undefined, email: string | null | undefined, username: string, workspaceName: string | null | undefined, roleName: Types.OrganizationRole | null | undefined } | null | undefined> | null | undefined };

export type OrgUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgUsersQuery = { __typename?: 'QueryPrediction', users: Array<{ __typename?: 'UserType', id: string, name: string | null | undefined, email: string | null | undefined, username: string, roleName: Types.OrganizationRole | null | undefined } | null | undefined> | null | undefined };

export type InvitedUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvitedUsersQuery = { __typename?: 'QueryPrediction', users: Array<{ __typename?: 'InvitedUserType', id: string, email: string | null | undefined, invited: boolean, roleName: string | null | undefined, accountCreatedAt: any | null | undefined, invitedUserMappings: Array<{ __typename?: 'InvitedUserTeamRoleType', id: string, teamRole: Types.TeamRoleEnum | null | undefined, team: { __typename?: 'TeamType', id: string, name: string } } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type InvitedUserQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type InvitedUserQuery = { __typename?: 'QueryPrediction', invited_user: { __typename?: 'InvitedUserType', id: string, email: string | null | undefined, invited: boolean, roleName: string | null | undefined, accountCreatedAt: any | null | undefined, invitedUserMappings: Array<{ __typename?: 'InvitedUserTeamRoleType', id: string, teamRole: Types.TeamRoleEnum | null | undefined, team: { __typename?: 'TeamType', id: string, name: string } } | null | undefined> | null | undefined } | null | undefined };

export type JoinRequestedUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type JoinRequestedUsersQuery = { __typename?: 'QueryPrediction', users: Array<{ __typename?: 'UserType', status: Types.ApprovalStatus | null | undefined, id: string, name: string | null | undefined, email: string | null | undefined, username: string, workspaceName: string | null | undefined, roleName: Types.OrganizationRole | null | undefined } | null | undefined> | null | undefined };

export type OrgApiKeysQueryVariables = Types.Exact<{
  username: Types.Scalars['String'];
}>;


export type OrgApiKeysQuery = { __typename?: 'QueryPrediction', orgApiKeysByUsername: Array<{ __typename?: 'UserAPIKeyType', prefix: string, lastUsed: any | null | undefined } | null | undefined> | null | undefined };


export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersPageUser"}}]}}]}},...MembersPageUserFragmentDoc.definitions,...OrgUserFragmentDoc.definitions]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const OrgUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgUserFragment"}}]}}]}},...OrgUserFragmentDoc.definitions]} as unknown as DocumentNode<OrgUsersQuery, OrgUsersQueryVariables>;
export const InvitedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvitedUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"invited_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersPageInvitedUser"}}]}}]}},...MembersPageInvitedUserFragmentDoc.definitions]} as unknown as DocumentNode<InvitedUsersQuery, InvitedUsersQueryVariables>;
export const InvitedUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvitedUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invited_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersPageInvitedUser"}}]}}]}},...MembersPageInvitedUserFragmentDoc.definitions]} as unknown as DocumentNode<InvitedUserQuery, InvitedUserQueryVariables>;
export const JoinRequestedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JoinRequestedUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"join_requested_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersPageUser"}}]}}]}},...MembersPageUserFragmentDoc.definitions,...OrgUserFragmentDoc.definitions]} as unknown as DocumentNode<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>;
export const OrgApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgAPIKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgApiKeysByUsername"},"name":{"kind":"Name","value":"org_api_keys_by_username"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"last_used_days"},"value":{"kind":"IntValue","value":"7"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefix"}},{"kind":"Field","alias":{"kind":"Name","value":"lastUsed"},"name":{"kind":"Name","value":"last_used"}}]}}]}}]} as unknown as DocumentNode<OrgApiKeysQuery, OrgApiKeysQueryVariables>;
export const namedOperations = {
  Query: {
    Users: 'Users',
    OrgUsers: 'OrgUsers',
    InvitedUsers: 'InvitedUsers',
    InvitedUser: 'InvitedUser',
    JoinRequestedUsers: 'JoinRequestedUsers',
    OrgAPIKeys: 'OrgAPIKeys'
  }
}

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
/**
 * __useOrgUsersQuery__
 *
 * To run a query within a React component, call `useOrgUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgUsersQuery(baseOptions?: Apollo.QueryHookOptions<OrgUsersQuery, OrgUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, options);
      }
export function useOrgUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgUsersQuery, OrgUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, options);
        }
export type OrgUsersQueryHookResult = ReturnType<typeof useOrgUsersQuery>;
export type OrgUsersLazyQueryHookResult = ReturnType<typeof useOrgUsersLazyQuery>;
export type OrgUsersQueryResult = Apollo.QueryResult<OrgUsersQuery, OrgUsersQueryVariables>;
export function refetchOrgUsersQuery(variables?: OrgUsersQueryVariables) {
      return { query: OrgUsersDocument, variables: variables }
    }
/**
 * __useInvitedUsersQuery__
 *
 * To run a query within a React component, call `useInvitedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvitedUsersQuery(baseOptions?: Apollo.QueryHookOptions<InvitedUsersQuery, InvitedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitedUsersQuery, InvitedUsersQueryVariables>(InvitedUsersDocument, options);
      }
export function useInvitedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitedUsersQuery, InvitedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitedUsersQuery, InvitedUsersQueryVariables>(InvitedUsersDocument, options);
        }
export type InvitedUsersQueryHookResult = ReturnType<typeof useInvitedUsersQuery>;
export type InvitedUsersLazyQueryHookResult = ReturnType<typeof useInvitedUsersLazyQuery>;
export type InvitedUsersQueryResult = Apollo.QueryResult<InvitedUsersQuery, InvitedUsersQueryVariables>;
export function refetchInvitedUsersQuery(variables?: InvitedUsersQueryVariables) {
      return { query: InvitedUsersDocument, variables: variables }
    }
/**
 * __useInvitedUserQuery__
 *
 * To run a query within a React component, call `useInvitedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitedUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvitedUserQuery(baseOptions: Apollo.QueryHookOptions<InvitedUserQuery, InvitedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitedUserQuery, InvitedUserQueryVariables>(InvitedUserDocument, options);
      }
export function useInvitedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitedUserQuery, InvitedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitedUserQuery, InvitedUserQueryVariables>(InvitedUserDocument, options);
        }
export type InvitedUserQueryHookResult = ReturnType<typeof useInvitedUserQuery>;
export type InvitedUserLazyQueryHookResult = ReturnType<typeof useInvitedUserLazyQuery>;
export type InvitedUserQueryResult = Apollo.QueryResult<InvitedUserQuery, InvitedUserQueryVariables>;
export function refetchInvitedUserQuery(variables: InvitedUserQueryVariables) {
      return { query: InvitedUserDocument, variables: variables }
    }
/**
 * __useJoinRequestedUsersQuery__
 *
 * To run a query within a React component, call `useJoinRequestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoinRequestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoinRequestedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useJoinRequestedUsersQuery(baseOptions?: Apollo.QueryHookOptions<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>(JoinRequestedUsersDocument, options);
      }
export function useJoinRequestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>(JoinRequestedUsersDocument, options);
        }
export type JoinRequestedUsersQueryHookResult = ReturnType<typeof useJoinRequestedUsersQuery>;
export type JoinRequestedUsersLazyQueryHookResult = ReturnType<typeof useJoinRequestedUsersLazyQuery>;
export type JoinRequestedUsersQueryResult = Apollo.QueryResult<JoinRequestedUsersQuery, JoinRequestedUsersQueryVariables>;
export function refetchJoinRequestedUsersQuery(variables?: JoinRequestedUsersQueryVariables) {
      return { query: JoinRequestedUsersDocument, variables: variables }
    }
/**
 * __useOrgApiKeysQuery__
 *
 * To run a query within a React component, call `useOrgApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgApiKeysQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrgApiKeysQuery(baseOptions: Apollo.QueryHookOptions<OrgApiKeysQuery, OrgApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgApiKeysQuery, OrgApiKeysQueryVariables>(OrgApiKeysDocument, options);
      }
export function useOrgApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgApiKeysQuery, OrgApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgApiKeysQuery, OrgApiKeysQueryVariables>(OrgApiKeysDocument, options);
        }
export type OrgApiKeysQueryHookResult = ReturnType<typeof useOrgApiKeysQuery>;
export type OrgApiKeysLazyQueryHookResult = ReturnType<typeof useOrgApiKeysLazyQuery>;
export type OrgApiKeysQueryResult = Apollo.QueryResult<OrgApiKeysQuery, OrgApiKeysQueryVariables>;
export function refetchOrgApiKeysQuery(variables: OrgApiKeysQueryVariables) {
      return { query: OrgApiKeysDocument, variables: variables }
    }